import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import UserSearch from './UserSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';

function UserSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.UserPage, [state.UserPage]);

    const [loader, setLoader] = useState(false);
    let apiTablePages;
    // setTablePages] = useState();

    useEffect(() => {
        const getUserSearchCuantity = async () => {
            try {
                setLoader(true);

                const userSearchCuantity = await UserService.totalRecords({
                    ...SearchParameters.usuarios,
                });

                if (userSearchCuantity) apiTablePages = userSearchCuantity.data;

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getUserSearch = async () => {
            try {
                setLoader(true);

                const UserSearch = await UserService.search({
                    ...SearchParameters.usuarios,
                    pagina: tablePage,
                });

                if (UserSearch) {
                    setTableData(
                        buildTableData(UserSearch.data, apiTablePages)
                    );
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getUserSearchCuantity();
        getUserSearch();
    }, [tablePage, SearchParameters.usuarios]);

    const buildTableData = (data = [], tablePages = 1) => {
        return {
            title: 'Lista de Usuarios',
            headers: [
                'Usuario',
                'Nombre',
                'Apellido',
                'Titulares',
                'RUT',
                'BPS',
                'Tipo',
                ' ',
            ],
            pagination: 10,
            tablePages,
            pageType: 'UserPage',
            data:
                data.length > 0
                    ? data?.map((u) => {
                          return {
                              usuario: u.usuario,
                              nombre: u.nombre,
                              apellido: u.apellido,
                              titulares: u.titulares,
                              rut: u.rut,
                              bps: u.bps,
                              tipo: masters.UserTypes?.find(
                                  (ut) => ut.id === u.tipo
                              )?.nombre,
                              icons: (
                                  <div>
                                      <Link
                                          to={RoutesApp.Profile + u.id}
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <UserSearch tableData={tableData} />;
}

export default UserSearchContainer;
